var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8404 17.082L13.4661 12.7078C14.6395 11.3588 15.3499 9.59867 15.3499 7.67494C15.3499 3.44035 11.9055 0 7.67495 0C3.44036 0 0 3.44435 0 7.67494C0 11.9055 3.44435 15.3499 7.67495 15.3499C9.59867 15.3499 11.3588 14.6395 12.7078 13.4661L17.082 17.8404C17.1858 17.9441 17.3255 18 17.4612 18C17.5969 18 17.7366 17.9481 17.8404 17.8404C18.0479 17.6328 18.0479 17.2896 17.8404 17.082ZM1.07361 7.67494C1.07361 4.03503 4.03503 1.07761 7.67095 1.07761C11.3109 1.07761 14.2683 4.03902 14.2683 7.67494C14.2683 11.3109 11.3109 14.2763 7.67095 14.2763C4.03503 14.2763 1.07361 11.3149 1.07361 7.67494Z",
    fill: "#00C853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f2752c3a0e931405b43046a07563fe1c.svg";
export { ForwardRef as ReactComponent };